// extracted by mini-css-extract-plugin
export default {"menu_container":"Menu_menu_container__Z7BHS","menu":"Menu_menu__8gw92"};